/**
 * @author Iskra Popova
 *
 * Layers class
 * Bui;ds ;ayers frpm assetworks layout config
 */

import ILayerMapConfig from "../baseConfigs/layerMapConfigSchema";
import ILayoutConfigSchema, { ILayersList, IViewConfigSchema, IObjectConfig } from "../baseConfigs/layoutConfigShema";
import SceneView from "../views/SceneView";
import Layer from "./Layer";
import DomLayer from "./DomLayer";
import App from "../App";
import GameEvents from "../../src/const/GameEvents";
import Layout from "./Layout";
import { Container, Rectangle, Graphics } from "pixi.js";

export default class Layers {

    protected layers: Map<string, Layer>;
    protected domBackground: DomLayer;
    protected layersContainer: Container;
    protected layersStaticBound: Rectangle;
    protected layersStaticBoundPortrait: Rectangle;
    protected marker: Graphics;
    protected marker2: Graphics;
    protected layerMap: Map<string, number>;
    protected sceneMap: Map<string, string[]>;
    protected layersConfig: ILayersList;
    protected domConfig: IObjectConfig[];
    protected secondarySceneMap: Map<string, string[]>;
    protected secondaryLayersConfig: ILayersList;
    protected secondaryDomConfig: IObjectConfig[];
    protected firstIndex: number;

    constructor(container: Container, layoutConfig: ILayoutConfigSchema, layerMapConfig: ILayerMapConfig, secondaryLayoutConfig?: ILayoutConfigSchema) {
        // this.marker = new Graphics();
        // this.marker.beginFill(0xff9a00);
        // this.marker.drawRect(0, 0, 20, 20);
        // this.marker.endFill();
        // this.marker2 = new Graphics();
        // this.marker2.beginFill(0xff0d07);
        // this.marker2.drawRect(0, 0, 20, 20);
        // this.marker2.endFill();
        this.layers = new Map<string, Layer>();
        this.layerMap = new Map<string, number>();
        this.sceneMap = new Map<string, string[]>();
        this.layersConfig = layoutConfig.layers;
        this.domConfig = layoutConfig.DOMElements;
        if (secondaryLayoutConfig) {

            this.secondaryLayersConfig = secondaryLayoutConfig.layers;
            this.secondaryDomConfig = secondaryLayoutConfig.DOMElements;
        }
        this.layersStaticBound = new Rectangle(0, 0, layoutConfig.settings.nativeWidth, layoutConfig.settings.nativeHeight);
        this.layersStaticBoundPortrait = new Rectangle(0, 0, layoutConfig.settings.nativeHeight, layoutConfig.settings.nativeWidth);
        if (this.domConfig && this.domConfig.length) {
            this.domBackground = new DomLayer(this.domConfig, document.getElementById(App.config.container_name));
        }

        this.layersContainer = container;
        let index = layerMapConfig.layers_count ;
        for ( const layer in  this.layersConfig ) {
            const sceneName = layer;
            const layerName = sceneName.split("-")[0].split("~")[0];
            let  zIndex = index;

            let layerFound = Object.keys(layerMapConfig.layers).find(
               (layer) => {
                   let layerFixed = layer
                       .split("-")[0]
                       .replace("~", "")
                       .replace("%", "");

                   return layerFixed == layerName;
               }
           )

            if (layerFound) {
                zIndex = layerMapConfig.layers[layerFound];
                index = zIndex - 1;
            }

            //console.log(layerName + " -> " + zIndex);

            this.layerMap.set(layerName, zIndex);

            if (!this.sceneMap.has(layerName)) {
                this.sceneMap.set(layerName, []);
            }

            if (this.sceneMap.get(layerName).indexOf(sceneName) === -1) {
                this.sceneMap.get(layerName).push(sceneName);
            }
        }

        const indices: number[] = [];
        this.firstIndex = container.children.length;
        this.layerMap.forEach((index, layer) => {
            this.layers.set(layer, new Layer(this.sceneMap.get(layer),this.layersStaticBound, layoutConfig.layers, layer, this.secondaryLayersConfig));
            indices.push(index);
            indices.sort((n1, n2) => n1 - n2);
            const depth = this.firstIndex  + indices.indexOf(index);

            container.addChildAt(this.layers.get(layer), depth);
        });

        App.dispatcher.on(GameEvents.RESIZE,this.onResize,this);
    }

    public resetZOrder() {
        const indices: number[] = [];
        this.layerMap.forEach((index, layer) => {
            this.layers.get(layer);
            indices.push(index);
            indices.sort((n1, n2) => n1 - n2);
            const depth = this.firstIndex + indices.indexOf(index);

            this.layersContainer.addChildAt(this.layers.get(layer), depth);
        });
    }

    public moveLayerBehind(layerToMove:string,layerToMoveBehindOf:string) {
        if(this.hasLayer(layerToMove) && this.hasLayer(layerToMoveBehindOf)) {
            let index = this.layersContainer.children.indexOf(this.layers.get(layerToMoveBehindOf));
            this.layersContainer.addChildAt(this.layers.get(layerToMove), index - 1);
        }
    }
    public moveLayerOnTop(layerToMove:string,layerToMoveOnTopOf:string) {
        if(this.hasLayer(layerToMove) && this.hasLayer(layerToMoveOnTopOf)) {
            let index = this.layersContainer.children.indexOf(this.layers.get(layerToMoveOnTopOf));
            this.layersContainer.addChildAt(this.layers.get(layerToMove), index + 1);
        }
    }

    public playDefault() {
        this.layers.forEach((layer) => {
            layer.playDefault();
        })
        if (this.hasDomBackground()) {
            this.domBackground.playDefault();
        }
        this.onResize();
    }

    public forceOrientationOnAllActive(orientation: "portrait"|"landscape", isException?: (layer: Layer) => boolean) {
        this.layers.forEach((layer) => {
            if (!isException || !isException(layer) ) {
                let scene = layer.getCurrentScene();
                if (scene) {
                    orientation === "landscape" ? scene.forceLandscape() : scene.forcePortrait();
                }
            }
        })

        this.onResize();
    }

    public getDomBackground(): DomLayer {
        return this.domBackground;
    }

    public hasDomBackground() {
        return this.domBackground != null && this.domBackground != undefined;
    }

    public getLayer(layer: DefaultLayers | string): Layer {
        if (!this.hasLayer(layer)) {
            throw new Error(("No layer found with name " + layer ));
        }

        return this.layers.get(layer);
    }

    public hasLayer(layer: DefaultLayers | string): boolean {
       return this.layers.has(layer);
    }

    public clearLayer(layer: string) {
        if (!this.hasLayer(layer)) {
            throw new Error(("No layer found with name " + layer ));
        }

        this.layers.get(layer).clear();

    }

    protected onResize(orientationChanged = false) {
        // const staticRect = this.layersStaticBound ;
        // if (!staticRect) {
        //     return;
        // }
        // const canvasWidth = App.instance.view.width / App.instance.renderer.resolution;
        // const canvasHeight = App.instance.view.height / App.instance.renderer.resolution;
        // staticRect.x = (canvasWidth / App.instance.stage.scale.x ) / 2 - Layout.scalePixels(staticRect.width) / 2;
        // staticRect.y = (canvasHeight / App.instance.stage.scale.x ) / 2 - Layout.scalePixels(staticRect.height) / 2;
        this.layers.forEach((layer) => {
            // layer.reposition(staticRect);
            layer.reposition(orientationChanged);
        })

    }


}

export enum DefaultLayers {
   Header = "Header",
   Preloader = "Preloader",
   BetBar = "BetBar",
   BetBarBottom = "BetBarBottom",
   InfoBar = "Infobar",
   Background = "Background",
   ReelsBack = "ReelsBack",
   Reels = "Reels",
   ReelsFront = "ReelsFront",
   Paylines = "Paylines",
   Anticipation = "Anticipation",
   Popups = "Popups",
   Banners = "Banners",
   MenusContent = "MenusContent",
   MenuUI = "MenuUI",
   MenusBackground = "MenusBackground",
   PaylineCelebration = "PaylineCelebration",
   SplashOverlay = "SplashOverlay",
   PauseOverlay = "PauseOverlay",
   FreegamesCounter = "FreegamesCounter",
   FreespinCounter = "FreespinCounter",
   RespinCounter = "RespinCounter",
   ReelsWin = "ReelsWin",
   CascadeHistory = "CascadeHistory"
}
